import { useMemo } from 'react';

import { type ListAddOnsResponse } from '@air/api';

import { useCurrentWorkspaceAddOns } from '~/swr-hooks/workspaces/addOns/useCurrentWorkspaceAddOns';

export type PrivateAddOnFeatures = {
  libraries?: boolean;
  assetTransforms?: Extract<ListAddOnsResponse['data'][number], { key: 'assetTransforms' }>['settings'] | boolean;
};

const DEFAULT_PRIVATE_ADD_ON_FEATURES: PrivateAddOnFeatures = {
  libraries: undefined,
  assetTransforms: undefined,
};

export const usePrivateAddOnFeatures = (): PrivateAddOnFeatures => {
  const { data: addOns, isPending } = useCurrentWorkspaceAddOns({ enabled: true });

  const addOnFeatures = useMemo(() => {
    if (isPending || !addOns?.data) {
      return DEFAULT_PRIVATE_ADD_ON_FEATURES;
    }

    const librariesAddOn = addOns.data.find((addOn) => addOn.key === 'libraries');
    const assetTransformsAddOn = addOns.data.find((addOn) => addOn.key === 'assetTransforms');

    return {
      libraries: librariesAddOn ? librariesAddOn.enabled === true && librariesAddOn.visible === true : false,
      assetTransforms:
        assetTransformsAddOn && assetTransformsAddOn.enabled === true && assetTransformsAddOn.visible === true
          ? assetTransformsAddOn.settings
          : false,
    };
  }, [isPending, addOns?.data]);

  return addOnFeatures;
};
